import {
  GET_RIDE_ANALYTICS,
  GET_RIDE_DETAILS,
  GET_TOTAL_REGISTRATION,
  GET_TOPCOMPANIES,
  GET_COMPANY_TRIP_STATS,
  GET_COMPANYDATA,
} from "resources/actionTypes";

export function getRideDetails(data) {
  return {
    type: GET_RIDE_DETAILS.GET_RIDE_DETAILS_REQUESTED,
    payload: data,
  };
}

export function getTotalRegistration(data) {
  return {
    type: GET_TOTAL_REGISTRATION.GET_TOTAL_REGISTRATION_REQUESTED,
    payload: data,
  };
}

export function getTopCompanies(data) {
  return {
    type: GET_TOPCOMPANIES.GET_TOPCOMPANIES_REQUESTED,
    payload:data
  };
}

export function getCompanyTripStats(data) {
  return {
    type: GET_COMPANY_TRIP_STATS.GET_COMPANY_TRIP_STATS_REQUESTED,
    payload: data,
  };
}

export function getRideAnalytic(data) {
  return {
    type: GET_RIDE_ANALYTICS.GET_RIDE_ANALYTICS_REQUESTED,
    payload: data,
  };
}

export function getCompanyData(data) {
  return {
    type: GET_COMPANYDATA.GET_COMPANYDATA_REQUESTED,
    payload: data,
  };
}
